import { useField } from 'formik'
import React from 'react'
import { Select } from '@mantine/core'

interface Option {
  key: string;
  value: string | number;
  text: string;
}

interface Props {
  placeholder?: string;
  name: string;
  options: Option[];
  label?: string;
}

export default function MySelectInput (props: Props) {
  const [field, meta, helpers] = useField(props.name)
  const mantineOptions = props.options.map((o) => ({ value: String(o.value), label: o.text }))
  return (
    <Select
      {...props}
      data={mantineOptions}
      value={field.value ? String(field.value) : null}
      onChange={(v) => helpers.setValue(v ?? '')}
      onBlur={() => helpers.setTouched(true)}
      error={meta.touched && meta.error}
      clearable
      sx={{ marginBottom: 12 }}
    />
  )
}
